import getElementStyleProperty from 'root/utils/getElementStyleProperty';

const progressIndicator = (el: HTMLElement, currentStep: number) => {
    const progressIndicatorEl = el?.querySelector<HTMLElement>(
        '[data-progress-indicator]'
    );
    const validClassName = 'js-progress-indicator-checked';
    const validateAllEarlierSteps = () => {
        const steps =
            el?.querySelectorAll<HTMLElement>('[data-progress-indicator-step-valid]') ||
            [];
        for (const step of steps) {
            if (Number(step.dataset.progressIndicatorStepValid) < currentStep) {
                step.classList.add(validClassName);
            }
        }
    };
    const validateFormStep = () => {
        const numberOfSlides = Number(
            progressIndicatorEl?.dataset.progressIndicatorStepsTotal
        );
        if (numberOfSlides) {
            const progressIndicatorLastStep = progressIndicatorEl?.querySelector(
                `[data-progress-indicator-step-valid="${numberOfSlides - 1}"]`
            );
            const endForm =
                el.closest<HTMLElement>('[data-form-all-fields-valid]') ||
                el.querySelector<HTMLElement>('[data-form-all-fields-valid]');
            const form = el.closest('[data-form=ls-form-steps]');
            const progressIndicatorFirstStep = progressIndicatorEl?.querySelector(
                `[data-progress-indicator-step-valid="0"]`
            );
            const isFormFieldsValid = endForm?.dataset.formAllFieldsValid === 'true';
            const validatePrepopulatedForm = () => {
                if (isFormFieldsValid && numberOfSlides === currentStep + 1) {
                    progressIndicatorLastStep?.classList.add(validClassName);
                }
            };
            const validateFormOnCustomEvent = () => {
                return endForm?.addEventListener('formFieldsValid', () => {
                    progressIndicatorLastStep?.classList.add(validClassName);
                });
            };
            const validateFormOnFirstStepValid = () => {
                return form?.addEventListener('firstStepFieldsValid', () => {
                    progressIndicatorFirstStep?.classList.add(validClassName);
                });
            };
            return {
                validatePrepopulatedForm,
                validateFormOnCustomEvent,
                validateFormOnFirstStepValid,
            };
        }
    };
    const syncProgressIndicatorToStep = () => {
        if (progressIndicatorEl) {
            if (currentStep - 1 >= 0) {
                validateAllEarlierSteps();
                validateFormStep()?.validatePrepopulatedForm();
                validateFormStep()?.validateFormOnCustomEvent();
            }

            if (currentStep === 0) {
                validateFormStep()?.validateFormOnFirstStepValid();
            }

            const progressIndicatorWidth = progressIndicatorEl.querySelector<HTMLElement>(
                '[data-progress-indicator-width]'
            );
            const labelWidth = progressIndicatorEl.querySelector<HTMLElement>(
                '[data-progress-indicator-label-width]'
            );

            if (progressIndicatorWidth) {
                progressIndicatorWidth.style.width = `calc(${currentStep} * ${getElementStyleProperty(
                    '--width',
                    progressIndicatorEl
                )} + ${getElementStyleProperty('--height', progressIndicatorEl)})`;
            }

            if (labelWidth) {
                labelWidth.style.width = `calc((${getElementStyleProperty(
                    '--width',
                    progressIndicatorEl
                )} + ${getElementStyleProperty(
                    '--offset',
                    progressIndicatorEl
                )})  * (${currentStep} + 1))`;
            }
        }
    };
    return {
        syncProgressIndicatorToStep,
        progressIndicatorEl,
    };
};

export { progressIndicator };
